export default __webpack_public_path__ + "static/media/etl.e85f5dc4.png";